import './index.css';
import { Text } from '../../../component';
import Constants from '../../../constants';
import AnswerSwitchBtn from '../answer_switch_btn';
import Button from '@mui/material/Button/Button';
import React from 'react';
import constants from '../../../constants';
import useTheme from '../../../utilities/hooks/theme';
import { useSelector } from 'react-redux';

interface Props {
  item?: any;
  qNo?: any;
  editMode?: any;
  onChangeMyAnswer?: any;
  onChange2x?: any;
  language?: any;
  onPressInsight?: any;
}

const YNAnswerView = ({
  item,
  qNo,
  editMode = false,
  onChangeMyAnswer,
  onChange2x,
  language = 'en',
  onPressInsight
}: Props) => {
  const {
    point = 0,
    answerStatus = false,
    isAnswered = false,
    questions = {},
    imageUrl = ''
  } = item;
  const { FantasyTheme: theme } = useTheme();
  const { themeType = '' } = useSelector((state: any) => state.setting);
  const scoreColor = point > 0 ? '#00ff3c' : '#f52100';
  const { english: en = '', hindi: hi = '' } = questions;
  const question = language === 'en' ? en : hi;
  const buttonText = item.answer
    ? language === 'en'
      ? 'Yes'
      : 'हाँ'
    : language === 'en'
    ? 'No'
    : 'नहीं';
  const doubleUpText = language === 'en' ? 'Double Up' : 'दोगुना\xa0\xa0\xa0\xa0';

  const imageLink = imageUrl ? imageUrl : Constants.Images.DefaultPlayerImage;
  const topSectionStyle = {
    background: theme.contestCardTopSectionBg,
    boxShadow: theme.contestCardTopSectionBoxShadow,
    border: `1px solid ${theme.contestCardBorder}`
  };
  const contestCardContainerColor = {
    background: theme.contestCardContainer,
    boxShadow: theme.contestCardBoxShadow,
    border: `1px solid ${theme.contestCardBorder}`
  };
  const imgContainerStyle = {
    border: `1px solid ${theme.contestCardBorder}`,
    background: theme.yesNoAnswerCardImgBg
  };
  const doubleUpContainerStyle = {
    background: theme.doubelUpContainerBg,
    border: `1px solid ${theme.contestCardBorder}`
  };
  const answerStatusStyle = {
    border: `1px solid ${theme.contestCardBorder}`
  };

  return (
    <>
      <div className="yes_no_question_card_wrapper">
        <div className="yes_no_question_card_container">
          <div className="yes_no_image_container" style={imgContainerStyle}>
            <img src={imageLink} width={'85px'} height={'85px'} />
          </div>
          <div className="yes_no_question_card_question_section">
            <div className="yes_no_question_card_top_section" style={topSectionStyle}>
              <div className="yes_no_question_card_question_no">{`Question : ${qNo}`}</div>
              <div className="yes_no_question_card_insights">
                {editMode && (
                  <div style={{ display: 'flex', position: 'relative' }} onClick={onPressInsight}>
                    <Constants.Svgs.Info />
                    <p>Insights</p>
                    {/* <SimpleDialog open={true} onClose={() => {}} /> */}
                  </div>
                )}
              </div>
            </div>
            <div
              className="yes_no_question_card_question_container"
              style={contestCardContainerColor}>
              <div
                className="yes_no_question_card_question"
                style={{ borderRight: `1px solid ${theme.contestCardBorder}` }}>
                {question}
              </div>
              <div className="yes_no_question_card_toggle_switch">
                {editMode ? (
                  <AnswerSwitchBtn
                    id={item.id + 'answer'}
                    checked={item.answer}
                    onChange={onChangeMyAnswer}
                    optionLabels={language === 'en' ? ['Yes', 'No'] : ['हाँ', 'नहीं']}
                  />
                ) : (
                  <Button
                    style={{
                      backgroundColor: '#8a8a8a',
                      color: '#fff',
                      width: '65px',
                      height: '25px',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                    className="YNAnsView__Btn">
                    {`${buttonText}`}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className="yes_no_question_card_double_up_container"
          onClick={onChange2x}
          style={doubleUpContainerStyle}>
          <img
            className="yes_no_question_card_double_up_img"
            src={
              item.isPowerUp
                ? themeType === 'dark'
                  ? constants.Images.YesNo_2xBtnSelect_dark
                  : constants.Images.YesNo_2xBtnSelect
                : themeType === 'dark'
                ? constants.Images.YesNo_2xBtn_dark
                : constants.Images.YesNo_2xBtn
            }
          />
          <div
            className="yes_no_question_card_double_up_txt"
            style={{ color: item.isPowerUp ? '#00ff3c' : 'white' }}>
            {doubleUpText}
          </div>
        </div>
        {isAnswered && (
          <div
            className="yes_no_question_card_points_status_container"
            style={doubleUpContainerStyle}>
            <div className="yes_question_card_answer_status" style={answerStatusStyle}>
              {answerStatus > 0 ? (
                <img src={constants.Images.questionCorrectTick} width={'20px'} />
              ) : (
                <img src={constants.Images.questionWrongClose} width={'20px'} />
              )}
            </div>
            <div className={'yes_question_card_answer_point'}>
              <Text
                style={{
                  color: scoreColor
                }}
                className={'YNAnsView__Point'}>
                {answerStatus ? `+${point}` : `${point}`}
              </Text>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default React.memo(YNAnswerView);
